import get from 'lodash/get';
import hasIn from 'lodash/hasIn';

export function hasErrors(
  errorResponse,
  objectPath = 'response.data.errors[0]',
) {
  return hasIn(errorResponse, objectPath);
}

export function getErrors(errorResponse, objectPath = 'response.data.errors') {
  return hasErrors(errorResponse)
    ? get(errorResponse, objectPath)
    : errorResponse && [errorResponse.message];
}
